import React from 'react'
import AdivsoryBoardModalButton from './AdvisoryBoardModalButton'
import { Row, Col } from 'react-bootstrap'
import {
     MartySattison,
     RobertSkinner,
     DonHulse,
     DougVetsch,
     TomDale,
     RussellJohnson,
     JayGeiger,
     WilliamPotter,
     GaryGrunewald
 } from './AdvisoryBoardMembers'

 import GoldDolphin from "../../images/gold-dolphin.jpg"
 import SilverDolphin from "../../images/silver-dolphin.jpg"
  import MartySattisonPhoto from "../../images/headshots/Marty_Sattison_flags_social.jpg"
  import RobertSkinnerPhoto from "../../images/headshots/Robert Skinner_flags_social.jpg"
  import TomDalePhoto from "../../images/headshots/Tom.Dale_9185Flags_social.jpg"
 import RussellJohnsonPhoto from "../../images/RussellJohnson.jpg"
 import JayGeigerPhoto from "../../images/headshots/Jay.Geiger_flags_social.jpg"
  import WilliamPotterPhoto from "../../images/headshots/William.Potter_flags_social.jpg"
 import GaryGrunewaldPhoto from "../../images/headshots/Gary.GrunewaldViceChairSouthWest_social.jpg"
 import DougVetschPhoto from "../../images/headshots/Doug.Vetsch_social.jpg"
 import AlanGriffittsPhoto from "../../images/headshots/Alan.Griffitts_social.jpg"
 import DavidMiskimensPhoto from "../../images/headshots/David.Miskimens_social.jpg"
 import StaticBoardCard from "./StaticBoardCard"

export default function Regionalcommittees(props) {
    

    return (
        <>
            <Row className="my-4">
            <Col sm={6}>
                <h5>North Idaho</h5>
                <AdivsoryBoardModalButton
                modalContent={DougVetsch}
                crewName="Doug Vetsch"
                position="North Idaho Regional Chair"
                teamMemberPhoto={DougVetschPhoto}
                rank="Commander US Navy (ret)"
                emblem={GoldDolphin}
            /> 
            <StaticBoardCard
                name="Alan Griffitts"
                position="North Idaho Regional Vice Chair"
                photo={AlanGriffittsPhoto}
            />
            <StaticBoardCard
                name="David Miskimens"
                position="North Idaho Regional Vice Chair"
                photo={DavidMiskimensPhoto}
            />
            </Col>
                <Col sm={6}>
                <h5>South Central Idaho</h5>
                <div>
                <AdivsoryBoardModalButton
                  modalContent={JayGeiger}
                  crewName="Jay Geiger"
                  position="Southcentral Idaho Regional Chair"
                  teamMemberPhoto={JayGeigerPhoto}
                  rank={
                    <>
                      Torpedoman Second Class (TM2)
                      <br />
                      US Navy Veteran
                    </>
                  }
                />
                <AdivsoryBoardModalButton
                  modalContent={WilliamPotter}
                  crewName="William Potter"
                  position="Vice Chair Southcentral Idaho Region"
                  teamMemberPhoto={WilliamPotterPhoto}
                />
            {/* <p>
              <strong>Tony Kevan</strong>
              <br />
              <em>Vice Chair Southcentral Idaho Region</em>
              
            </p> */}
          </div>
            </Col>
            </Row>
            <Row className="my-4">
                <Col sm={6}>
                <div className="mb-4">
                <h5>South West Idaho</h5>
                <AdivsoryBoardModalButton
                  modalContent={TomDale}
                  crewName="Tom Dale"
                  position="Southwest Idaho Regional Chair"
                  teamMemberPhoto={TomDalePhoto}
                  rank={
                    <>
                      Musician Second Class (MU2)
                      <br />
                      US Navy Veteran
                    </>
                  }
                //emblem={SilverDolphin}
            />
            </div>   
            <div
          className="mb-4">
          <AdivsoryBoardModalButton
                modalContent={GaryGrunewald}
                crewName="Gary Grunewald"
                position="Southwest Idaho Regional Vice Chair"
                teamMemberPhoto={GaryGrunewaldPhoto}
                rank="Machinist Mate 1st Class MM1 (SS), US Navy Veteran"
                emblem={SilverDolphin}
            /> 
        </div>

        <div
          className="mb-4"
          style={{
            width: "100%",
            display: "flex",
          }}
        >
          {/* <div
            style={{
              width: "100px",
              marginRight: "10px",
            }}
          >
            <img
              className="rounded "
              src={TomDalePhoto}
              style={{
                width: "100px",
              }}
            />
          </div> */}
          <div>
            <p>
              <strong>Ron Dale</strong>
              <br />
              <em>Treasurer Southwest Idaho Region</em>
              
            </p>
          </div>
          {/* <div style={{ width: "120px" }}>
            <img src={SupplyOfficer} style={{ width: "120px" }} />
          </div> */}
        </div>
              </Col>
                <Col sm={6}>
                <h5>South East Idaho</h5>
                <div className="mb-4">
                <AdivsoryBoardModalButton
                modalContent={MartySattison}
                crewName="Marty Sattison"
                position="Southeast Idaho Regional Chair"
                teamMemberPhoto={MartySattisonPhoto}
                rank="Captain US Navy (ret)"
                emblem={GoldDolphin}
            /> </div>
               
            <div className="mb-4">
                <AdivsoryBoardModalButton
                modalContent={RobertSkinner}
                crewName="Robert Skinner"
                position="Vice Chair Southeast Idaho Region"
                teamMemberPhoto={RobertSkinnerPhoto}
                rank="Captain US Navy (ret)"
                emblem={SilverDolphin}
            /> </div>
            
            <div className="mb-4">
                <AdivsoryBoardModalButton
                modalContent={DonHulse}
                crewName="Don Hulse"
                position="Vice Chair Southeast Idaho Region Emeritus"
                //teamMemberPhoto={RobertSkinnerPhoto}
                rank="EMC (ss) US Navy (ret)"
                emblem={SilverDolphin}
            /> </div>
        
        
                </Col>
            </Row>
        </>
    )
}


